import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { useAppSelector } from '../../../store/hooks'
import { chartColorVariants } from './chartsUtil'

const BarChart = ({ data }) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [chartData, setChartData] = useState({})
    const [chartOptions, setChartOptions] = useState({})

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement)
        const textColor = documentStyle.getPropertyValue(
            theme === 'dark' ? '--bs-white' : '--bs-black'
        )
        const textColorSecondary = documentStyle.getPropertyValue(
            '--text-color-secondary'
        )
        const surfaceBorder =
            documentStyle.getPropertyValue('--bs-border-color')

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.7,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        }

        let finalisedChartData = data
        const dataSets = data?.['datasets'] || []

        for (const i in dataSets) {
            finalisedChartData['datasets'][i]['type'] = 'bar'
            finalisedChartData['datasets'][i]['borderWidth'] = 1
            finalisedChartData['datasets'][i]['fill'] = true

            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                finalisedChartData['datasets'][i]['borderColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                finalisedChartData['datasets'][i]['backgroundColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                    '30'
            }
        }

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [theme, data])

    return <Chart type="line" data={chartData} options={chartOptions} />
}

export default BarChart
